import React from "react";
import { useActionRight } from "../hooks/useActionRight";

const disabledFieldsetStyle = {
  border: 0,
  padding: 0,
  margin: 0,
  minWidth: 0,
  width: "100%",
};

/**
 * Hidden actions are omitted. Disable keeps the button visible but unusable,
 * including for children that ignore a `disabled` prop.
 */
const ActionPermissionGate = ({
  entity,
  action,
  requireFullAccess = true,
  children,
}) => {
  const { isActionVisible, isActionEnabled } = useActionRight();

  if (!isActionVisible(entity, action)) return null;

  const enabled = isActionEnabled(entity, action, { requireFullAccess });
  const child = React.Children.only(children);
  const gated = React.cloneElement(child, {
    disabled: Boolean(child.props.disabled) || !enabled,
  });

  return (
    <fieldset
      disabled={!enabled}
      aria-disabled={!enabled}
      style={{
        ...disabledFieldsetStyle,
        pointerEvents: enabled ? undefined : "none",
        opacity: enabled ? 1 : 0.45,
      }}
      onClickCapture={(event) => {
        if (enabled) return;
        event.preventDefault();
        event.stopPropagation();
      }}
    >
      {gated}
    </fieldset>
  );
};

export default ActionPermissionGate;
